var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mtop'),_c('div',{staticClass:"mux-l"}),_c('router-view'),_c('mbot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }